import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-tip"]
const _hoisted_2 = { class: "btn btn-secondary btn-sm btn-circle" }
const _hoisted_3 = { class: "m-4" }

import PopupButton from "@/components/utils/PopupButton.vue";
import type { Placement } from "@popperjs/core/lib/enums";


export default /*@__PURE__*/_defineComponent({
  __name: 'QuickToolButton',
  props: {
    placement: {},
    tooltip: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupButton, {
    placement: _ctx.placement ?? 'auto',
    offset: 7
  }, {
    button: _withCtx(() => [
      _createElementVNode("div", {
        class: "tooltip tooltip-secondary",
        "data-tip": _ctx.tooltip
      }, [
        _createElementVNode("button", _hoisted_2, [
          _renderSlot(_ctx.$slots, "icon")
        ])
      ], 8, _hoisted_1)
    ]),
    popup: _withCtx((slotProps) => [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "popup", {
          visible: slotProps.visible,
          forceUpdate: slotProps.forceUpdate
        })
      ])
    ]),
    _: 3
  }, 8, ["placement"]))
}
}

})